class Doresize {

  constructor() {
    this.init();
  }

  init() {
    if (window.matchMedia("(min-width: 0px)").matches) {
    
      let $element = $("#doek");
      console.log($element);
      
      let elHeight = $element.innerHeight();
      let elWidth = $element.innerWidth();
      
      let $wrapper = $("#doekwrapper");
      
      function doResize(event, ui) {
        
          var scale;
            
          scale = Math.min(
            ui.size.width / elWidth,    
            ui.size.height / (elHeight)
          );
          
          $element.css({
            transform: "translate(-50%, -50%) " + "scale(" + scale + ")"
          });
      
      
          
        }
      
        var starterData = { 
          size: {
            width: Math.round($wrapper.innerWidth()),
            height: Math.round($wrapper.innerHeight())
          }
        }
      
        doResize(null, starterData);
      
      
      window.addEventListener('resize', function() {
      
          var starterData = { 
              size: {
                width: Math.round($wrapper.innerWidth()),
                height: Math.round($wrapper.innerHeight())
              }
            }
      
          doResize(null, starterData);
      
      
      });
      
      function meetEnRondAfDoek() {
        let $element = $("#doekwrapper");
      
        // Meet de huidige afmetingen
        let elHeight = $element.innerHeight();
        let elWidth = $element.innerWidth();
      
        // Rond af op hele getallen
        let afgerondeHoogte = Math.round(elHeight);
        let afgerondeBreedte = Math.round(elWidth);
      
        console.log(afgerondeHoogte, afgerondeBreedte)
      
        // Optioneel: Update de afmetingen van #doek met de afgeronde waarden
        $element.css({
          height: afgerondeHoogte   + 'px',
          width: afgerondeBreedte  +  'px'
        });
      
        // Retourneer de afgeronde afmetingen
        return {
          hoogte: afgerondeHoogte,
          breedte: afgerondeBreedte
        };
      }
      }
    
    }
}



window.Doresize = Doresize;

export default Doresize;
